import { render, staticRenderFns } from "./studyContent.vue?vue&type=template&id=3782ec77&scoped=true&"
import script from "./studyContent.vue?vue&type=script&lang=js&"
export * from "./studyContent.vue?vue&type=script&lang=js&"
import style0 from "./studyContent.vue?vue&type=style&index=0&id=3782ec77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3782ec77",
  null
  
)

export default component.exports